import domContentLoaded from 'dom-content-loaded';
import $ from 'jquery';

export default () => {
	domContentLoaded(() => {
		$('.js-toggle').each((index, element) => {
			const $toggle = $(element);
			const $trigger = $toggle.find('.js-toggle-trigger');
			const $content = $toggle.find('.js-toggle-content');
			$trigger.on('click', () => {
				const flag = $toggle.hasClass('toggle-open');
				if (flag) {
					$content.slideUp(300);
					$toggle.removeClass('toggle-open');
				} else {
					$content.slideDown(300);
					$toggle.addClass('toggle-open');
				}
			});
		});
	});
};
